module.exports = __webpack_public_path__ + "static/media/31.21d07822.wav";